import { render, staticRenderFns } from "./DettaglioSconto.vue?vue&type=template&id=7b6f4d42&"
import script from "./DettaglioSconto.vue?vue&type=script&lang=js&"
export * from "./DettaglioSconto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports